import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            layerStyle: 'full-width',
            flexDirection: 'column',
        },
        header: {
            textStyle: 'head-xsmall',
            fontWeight: '500',
            color: 'text.default',
        },
        gridSection: {
            templateColumns: {base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)'},
        },
    },
    variants: {
        manuals: {
            container: {
                padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
                marginBottom: 'large.lg',
            },
            header: {
                marginBottom: 'large.base',
            },
            gridSection: {
                gap: {base: 'xsmall.base', lg: 'medium.base'},
            },
        },
        faqs: {
            container: {
                alignItems: {
                    base: 'center',
                    lg: 'flex-start',
                },
                h: '100%',
                w: '100%',
                layerStyle: 'null',
            },
            gridSection: {
                w: '100%',
                rowGap: {base: remCalc(40), lg: remCalc(80)},
                columnGap: {base: remCalc(8), lg: remCalc(24)},
                autoRows: '1fr',
            },
        },
    },

    parts: ['container', 'header', 'gridSection'],
}
